export default [
    {
        path: '/admin/academic/exam-registers',
        name: 'exam-register',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/exam-register/index.vue')
    },
    {
        path: '/admin/academic/exam-registers/create',
        name: 'exam-register-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/exam-register/create.vue')
    },
]

